// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","tooltip":"tooltip_tooltip__Z3M90","help":"tooltip_help__TRjXR","tooltipText":"tooltip_tooltipText__wzpDD","bottom":"tooltip_bottom__llcvd"};